import React, { useState } from 'react'
import { send } from 'emailjs-com';
import swal from 'sweetalert';
import Zoom from 'react-reveal/Zoom';
import { init } from '@emailjs/browser';
init("user_mpNvNFaQKvLc31iQOvivW");





const Contacto = () => {

    const [toSend, setToSend] = useState({
        from_name: '',
        telefono: '',
        asunto: '',
        mensaje: '',
        email: '',

    });

    const user_id = "user_mpNvNFaQKvLc31iQOvivW"
    const service_id = "service_93jlw4f"
    const template_id = "template_03wsi3o"



    const onSubmit = (e) => {
        e.preventDefault();

        console.log(toSend)
        send(
            service_id,
            template_id,
            toSend,
            user_id
        )


            .then((response) => {
                //console.log('SUCCESS!', response.status, response.text);
                swal({
                    buttons: false,
                    timer: 3000,
                    title: "Gracias!!",
                    icon: "success",
                });

                setToSend({
                    from_name: '',
                    telefono: '',
                    asunto: '',
                    mensaje: '',
                    email: '',
                })


            })
            .catch((err) => {
                console.log('FAILED...', err);
            });
    };
    const handleChange = (e) => {
        setToSend({ ...toSend, [e.target.name]: e.target.value });
    };


    return (


<Zoom> 
         <div>
            <section className="contact">

            <h1 className="heading"> contato <span>me</span></h1>

                <div className="row">

                    <div className="info-container">


                        <div className="box-container">

                            <div className="box">
                                <i className="fas fa-map"></i>
                                <div className="info">
                                    <h3>Endereço :</h3>
                                    <p>São Paulo - Brasil</p>
                                </div>
                            </div>

                            <div className="box">
                                <i className="fas fa-envelope"></i>
                                <div className="info">
                                    <h3>email :</h3>
                                    <p>diegoteran4@gmail.com</p>
                                </div>
                            </div>



                        </div>

                        <div className="share">
                            <a href="https://www.facebook.com/diego.teran.547"className="fab fa-facebook-f"></a>
                            <a href="#"className="fab fa-google-plus"></a>
                            <a href="https://www.instagram.com/browninstagra/"className="fab fa-instagram"></a>
                            <a href="https://www.linkedin.com/in/diego-teran-5b100682/"className="fab fa-linkedin"></a>
                        </div>

                    </div>

                    <form onSubmit={onSubmit}>

                        <div className="inputBox">
                            <input type="text" name="from_name" placeholder="Nome"
                                required
                                value={toSend.from_name}
                                onChange={handleChange}
                            />

                            <input type="number" name="telefono" placeholder="Telefone"
                                required
                                value={toSend.telefono}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="inputBox">
                            <input type="email" name="email" placeholder="Email"
                                required
                                value={toSend.email}
                                onChange={handleChange}
                            />

                            <input type="text" name="asunto" placeholder="Assunto"
                                required
                                value={toSend.asunto}
                                onChange={handleChange}
                            />
                        </div>

                        <textarea name="mensaje" placeholder="Mensagem" id="" cols="30" rows="10"
                            value={toSend.mensaje}
                            onChange={handleChange}>
                        </textarea>

                        <input type="submit" value="Enviar"className="btn" />

                    </form>

                </div>

            </section>


        </div>
</Zoom> 
    )
}

export default Contacto
